export default {"src":"/_next/static/media/apple.c4352461.svg","height":1000,"width":842,"blurWidth":0,"blurHeight":0};